const comments = [
  {
    name: '影迷小张',
    text: '用了7788电影网两年了，画质和流畅度真的没话说。电影排行榜也很靠谱，按榜单看片基本不会踩雷，推荐给身边所有朋友了！',
    rating: 5,
    time: '2天前',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimal%20avatar%20style%20icon%20with%20warm%20amber%20and%20coral%20gradient%20background%2C%20abstract%20geometric%20shape%2C%20clean%20modern%20design%2C%20no%20text%2C%20no%20faces&width=80&height=80&seq=avatar-comment1&orientation=squarish',
  },
  {
    name: '电影控阿杰',
    text: '片库真的很全！从老港片到最新好莱坞大片都能找到，更新速度也快。不缓冲这个真的要点赞，晚上高峰期看片也丝般顺滑。',
    rating: 5,
    time: '3天前',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimal%20avatar%20style%20icon%20with%20warm%20teal%20and%20mint%20gradient%20background%2C%20abstract%20geometric%20shape%2C%20clean%20modern%20design%2C%20no%20text%2C%20no%20faces&width=80&height=80&seq=avatar-comment2&orientation=squarish',
  },
  {
    name: '周末观影人',
    text: '作为悬疑片爱好者，这里的分类和推荐做得太棒了。电影大全涵盖的类型很全，还能看到其他影迷的热评，找片效率高多了。',
    rating: 4,
    time: '5天前',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimal%20avatar%20style%20icon%20with%20warm%20plum%20and%20rose%20gradient%20background%2C%20abstract%20geometric%20shape%2C%20clean%20modern%20design%2C%20no%20text%2C%20no%20faces&width=80&height=80&seq=avatar-comment3&orientation=squarish',
  },
  {
    name: '追剧小能手',
    text: '免费高清这个真的良心。之前用别的站不是卡就是糊，7788电影网的清晰度和流畅度完全不在一个水平上，已经成为日常必备了。',
    rating: 5,
    time: '1周前',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimal%20avatar%20style%20icon%20with%20warm%20golden%20and%20orange%20gradient%20background%2C%20abstract%20geometric%20shape%2C%20clean%20modern%20design%2C%20no%20text%2C%20no%20faces&width=80&height=80&seq=avatar-comment4&orientation=squarish',
  },
];

export default function Comments() {
  return (
    <section id="comments" className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950">
            影迷热评
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-500">
            来自真实影迷的观影反馈与推荐
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {comments.map((c) => (
            <div
              key={c.name}
              className="rounded-xl bg-background-50 p-5"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={c.avatar}
                    alt={c.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="min-w-0">
                  <p className="text-sm font-bold font-heading text-foreground-900 truncate">
                    {c.name}
                  </p>
                  <div className="flex items-center gap-0.5 mt-0.5">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i
                        key={i}
                        className={`text-xs ${
                          i < c.rating
                            ? 'ri-star-fill text-accent-500'
                            : 'ri-star-line text-foreground-300'
                        }`}
                      ></i>
                    ))}
                  </div>
                </div>
                <span className="ml-auto text-xs text-foreground-400 whitespace-nowrap flex-shrink-0">
                  {c.time}
                </span>
              </div>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {c.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}